import { render, staticRenderFns } from "./TrainingWebinarListing.vue?vue&type=template&id=008d87b2&scoped=true"
import script from "./TrainingWebinarListing.vue?vue&type=script&lang=js"
export * from "./TrainingWebinarListing.vue?vue&type=script&lang=js"
import style0 from "./TrainingWebinarListing.vue?vue&type=style&index=0&id=008d87b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d87b2",
  null
  
)

export default component.exports